import { Injectable } from '@angular/core';

import { StakeConfig } from '@frontend/sports/common/client-config-data-access';

import { ISlip } from '../../../../bet-generation/models';
import { isFreebetToken } from '../../../../reward-tokens/services/reward-tokens.utils';
import { getSlipTotalStakeAndBetCount } from '../../../../summary/services/betslip-summary-helpers';
import { OverMaximumStakePreCheckError } from '../../../errors/pre-check/over-maximum-stake-pre-check-error';
import { SlipValidationContext } from '../../../models/models';
import { IContextSlipValidator } from './validators';

@Injectable()
export class OverMaximumStakeValidator implements IContextSlipValidator<OverMaximumStakePreCheckError> {
    constructor(private stakeConfig: StakeConfig) {}

    *validate(slip: ISlip, context: SlipValidationContext): Iterable<OverMaximumStakePreCheckError> {
        const maximumStake = context.maximumStake;

        if (this.stakeConfig.isMaxStakePerBetslipStrategy) {
            // max stake validated per betslip
            return;
        }

        if (maximumStake == null) {
            // No maximum stake
            return;
        }

        if (slip.stake == null || isFreebetToken(slip.rewardToken)) {
            // Slip without stake or has freebet.
            return;
        }

        const { totalStake, betCount } = getSlipTotalStakeAndBetCount(slip);

        if (totalStake && totalStake.greaterThan(maximumStake)) {
            yield new OverMaximumStakePreCheckError(maximumStake.toNumber(), totalStake.toNumber(), betCount);
        }
    }
}
